document.addEventListener('DOMContentLoaded', () => {
  const closings = document.querySelectorAll('[data-closing]');

  closings.forEach((closing) => {
    const atcForm = closing.querySelector('[data-closing-atc]');
    if (!atcForm) return;

    atcForm.addEventListener('submit', (event) => {
      event.preventDefault();
      const submitButton = atcForm.querySelector('button[type="submit"]');
      window.lhLandingsAddToCart(atcForm, submitButton);
    });
  });
});
